// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyDm8rtGtY7yyMITo6jYTTGGQY2HHEg7sCM',
    authDomain: 'ibd-tool-mauriziano.firebaseapp.com',
    databaseURL: 'https://ibd-tool-mauriziano.firebaseio.com',
    projectId: 'ibd-tool-mauriziano',
    storageBucket: 'ibd-tool-mauriziano.appspot.com',
    messagingSenderId: '962693807037',
    appId: '1:962693807037:web:d408e2e9b107b108a270d4',
    measurementId: 'G-LK71FSP2BX'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
